import React from 'react'
import Navbar from '../Components/Navbar'
import New from '../Components/New'
import Footer from '../Components/Footer'


const News = () => {
  return (
    <>
      <Navbar />
      <New />
      <Footer />
    </>

  )
}

export default News


